type IReasonID =
  | 'not_enough_information'
  | 'no_created_offer'
  | 'amount_too_high'
  | 'missing_skills'
  | 'location_too_far'
  | 'no_availability'
  | 'unresponsive'
  | 'did_not_agree'
  | 'other';

export const declineReasons = new Map<string, { reasonId: IReasonID }>([
  ['1', { reasonId: 'not_enough_information' }],
  ['2', { reasonId: 'no_created_offer' }],
  ['3', { reasonId: 'amount_too_high' }],
  ['4', { reasonId: 'missing_skills' }],
  ['5', { reasonId: 'location_too_far' }],
  ['6', { reasonId: 'no_availability' }],
  ['7', { reasonId: 'unresponsive' }],
  ['8', { reasonId: 'did_not_agree' }],
  ['9', { reasonId: 'other' }]
]);
